import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? "text-neon-purple font-bold" : "hover:text-neon-purple transition-colors";

  return (
    <nav className="fixed top-0 w-full bg-white/80 dark:bg-[#050505]/80 backdrop-blur-md z-50 p-6 flex justify-between items-center max-w-6xl mx-auto left-0 right-0">
      <Link to="/" className="font-bold text-xl text-neon-purple tracking-tighter uppercase">Anis LAFRAD</Link>
      <div className="hidden md:flex space-x-8 text-sm font-medium">
        <Link to="/" className={isActive('/')}>Accueil</Link>
        <Link to="/projets" className={isActive('/projets')}>Projets</Link>
        <Link to="/outils" className={isActive('/outils')}>Outils</Link>
        <Link to="/veille" className={isActive('/veille')}>Veille</Link>
      </div>
    </nav>
  );
};

export default Navbar;